export const Constants = {
    LEFT_ARROW : '#app-emi-carousel-left-arrow',
    RIGHT_ARROW : '#app-emi-carousel-right-arrow',
    CARD_LIST : '#app-emi-carousel-cardlist',
    POSITION_ATTRIBUTE : 'data-emi-carousel-position',
    CARDS : '.app-emi-carousel-card',
    MOBILE_MEDIA: 'only screen and (max-width: 768px)',
    CLICK_EVENT: 'click',
}

export default class Carousel{


    /**
     * Check if current media is mobile or not
     * @returns boolean
     */
    static isMobile(){
        return window.matchMedia( Constants.MOBILE_MEDIA ).matches;
    }

    static render( configuration ){
        Carousel.createScene( configuration ) ;
        Carousel.render3D();
        Carousel.addArrowsEventListeners();
        Carousel.addCardsEventListeners(configuration);



        // Listen to Maestro by subscribing to the event bus
        Maestro.getInstance().Store.save(`tarot-status`, { initialized: true });
        Maestro.getInstance()
            .EventBus.on(`tarot-stop`, () => {
                // Stop the module
                configuration.stop();
                configuration.log();
                let cardList = document.querySelector('#app-emi-tarot-carousel-main');
                cardList.setAttribute('tarot-disabled', true);
                document.querySelector('#title-start').classList.add('app-emi-none');
                document.querySelector('#title-result').classList.remove('app-emi-none');
            })
            .on(`tarot-start`, (e) => {
                // Restart the module
                configuration.start();
                configuration.log();
                let cardList = document.querySelector('#app-emi-tarot-carousel-main');
                cardList.setAttribute('tarot-disabled', false);
                document.querySelector('#title-start').classList.remove('app-emi-none');
                document.querySelector('#title-result').classList.add('app-emi-none');
            });
    }

    static addCardsEventListeners(cardDeck){
        const cards = document.querySelectorAll( Constants.CARDS);
        cards.forEach((card)=>{
            card.addEventListener( Constants.CLICK_EVENT, (event)=>{
                Carousel.onCardClick(event, cardDeck);
            })
        })
    }

    static isCardSelected(card){
        return card.classList.contains('carousel-card-selected');
    }

    static unselectCard(card){
        card.classList.remove('carousel-card-selected');
    }

    static onCardClick(event, configuration){
        const position = parseInt( document.querySelector(Constants.CARD_LIST).getAttribute(Constants.POSITION_ATTRIBUTE) );
        const index = parseInt( event.target.getAttribute('data-emi-carousel-index') );
        if( index === position && !event.target.getAttribute('card-selected')){
            // Reveal Card
            if (configuration.state.selected.length < configuration.config.amount) {
                event.target.classList.add('carousel-card-selected');
                event.target.setAttribute('card-selected', true);
                event.target.style.transform = event.target.style.transform.concat(' rotateY(360deg)');
                setTimeout(()=>{
                    event.target.style.backgroundImage = `url(${configuration.deck[index].source})`;
                },150);
                configuration.state.selected.push(index);
            }
            else {
                configuration.stop();
                document.querySelector(Constants.CARD_LIST).classList.add('status--disabled');
                document.getElementById(`app-emi-tarot`).classList.add('status--disabled');
            }
            Maestro.getInstance().EventBus.emit(`tarot-card-selected`, configuration.result());
        } else if( index > position ) {

            let cardList = document.querySelector('#app-emi-tarot-carousel-main');
            if(cardList.getAttribute('tarot-disabled') === 'false'){
                // Move Carousel
                Carousel.onRightArrowClick();
                const cards = document.querySelectorAll( Constants.CARDS);
                cards.forEach((card)=>{
                    Carousel.unselectCard(card);
                })
            }

            
        } else if( index < position ) {
            let cardList = document.querySelector('#app-emi-tarot-carousel-main');
            if(cardList.getAttribute('tarot-disabled') === 'false'){
                // Move Carousel
                Carousel.onLeftArrowClick();
                const cards = document.querySelectorAll( Constants.CARDS);
                cards.forEach((card)=>{
                    Carousel.unselectCard(card);
                })
            }
        }
    }

    static addArrowsEventListeners(){
        const arrL = document.querySelector( Constants.LEFT_ARROW );
        arrL.addEventListener( Constants.CLICK_EVENT, ()=>{
            Carousel.onLeftArrowClick();
            const cards = document.querySelectorAll( Constants.CARDS);
            cards.forEach((card)=>{
                Carousel.unselectCard(card);
            })
        })

        const arrR = document.querySelector( Constants.RIGHT_ARROW );
        arrR.addEventListener( Constants.CLICK_EVENT, ()=>{
            Carousel.onRightArrowClick();
            const cards = document.querySelectorAll( Constants.CARDS);
            cards.forEach((card)=>{
                Carousel.unselectCard(card);
            })
        })
    }

    static calculateLeftPosition( currentPosition ){
        return currentPosition - 1 > 0 ? currentPosition - 1 : 0
    }

    static calculateRightPosition( currentPosition, cardElements ){
        return currentPosition < cardElements.length - 1  ? Number( currentPosition ) + 1 : cardElements.length - 1
    }

    static onLeftArrowClick(){
        const elt = document.querySelector( Constants.CARD_LIST );
        const position = elt.getAttribute( Constants.POSITION_ATTRIBUTE );
        elt.setAttribute( Constants.POSITION_ATTRIBUTE, Carousel.calculateLeftPosition( Number( position ) ) );
        Carousel.render3D();
    }

    static onRightArrowClick(){
        const elt = document.querySelector( Constants.CARD_LIST )
        const position = elt.getAttribute( Constants.POSITION_ATTRIBUTE );
        const cardElements = document.querySelectorAll( Constants.CARDS );
        elt.setAttribute( Constants.POSITION_ATTRIBUTE, Carousel.calculateRightPosition( Number( position ), cardElements ) );
        Carousel.render3D();
    }

    static createScene(configuration){

        console.log( configuration );

        //identifies the widget html element
        const widgetHtmlElement = document.querySelector('#app-emi-tarot');
        //empty the html of the widget element - in case of already rendered widget tarot
        widgetHtmlElement.innerHTML = '';

        //create title space
        //create the fragment - fragment have better performance than direct html element
        const sceneFragment = document.createDocumentFragment();

        const titleParams = {
            start: configuration.title.start,
            result: configuration.title.end
        }
        sceneFragment.appendChild( Carousel.createTitle(titleParams) );

        sceneFragment.appendChild( Carousel.createCarousel(configuration) );

        const tirageHtmlElement = document.createElement('section');
        tirageHtmlElement.id = 'app-emi-tarot-carousel-draws';

        sceneFragment.appendChild(tirageHtmlElement);

        widgetHtmlElement.appendChild(sceneFragment);

    }

    static createTitle(titleParams){
        const titleHtmlElement = document.createElement('section');
        titleHtmlElement.id = 'app-emi-tarot-carousel-title';

        titleHtmlElement.appendChild( Carousel.createElement({
            tag: 'h2',
            html: titleParams.start,
            id: 'title-start',
        }));

        titleHtmlElement.appendChild( Carousel.createElement({
            tag: 'h2',
            html: titleParams.result,
            id: 'title-result',
            classes: ['app-emi-none']
        }));

        return titleHtmlElement;
    }

    static createElement(parameters){
        const elt = document.createElement(parameters.tag);

        if(parameters.id) elt.id = parameters.id;

        if(parameters.html) elt.innerHTML = parameters.html;

        if(parameters.classes && parameters.classes.length > 0){
            for(let i = 0; i < parameters.classes.length; i++){
                elt.classList.add( parameters.classes[i] );
            }
        }

        if(parameters.attributes && parameters.attributes.length > 0){
            for(let i = 0; i < parameters.attributes.length; i++){
                elt.setAttribute(parameters.attributes[i].key, parameters.attributes[i].value);
            }
        }

        if( parameters.style){
            elt.style = parameters.style;
        }

        return elt;
    }

    static createCarousel(configuration){
        const carouselHtmlElement = Carousel.createElement({
            tag: 'section',
            id: 'app-emi-tarot-carousel-main',
        });

        const leftArrowContainer = Carousel.createElement({
            tag: 'div',
            id: 'app-emi-carousel-left-arrow',
            html: '<svg style="width:100%;height:48px" viewBox="0 0 24 24"><path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>'
        });

        carouselHtmlElement.appendChild(leftArrowContainer);

        const cardListContainer = Carousel.createElement({
            tag: 'div',
            id: 'app-emi-carousel-cardlist',
            attributes:  [{key: 'data-emi-carousel-position', value: '3'}]
        })

        for(let i  = 0; i < configuration.deck.length; i++){

            let cardContainer = Carousel.createElement({
                tag: 'article',
                id: 'card-'.concat(i.toString()),
                classes: ['app-emi-carousel-card'],
                attributes: [{
                    key: 'data-emi-carousel-index',
                    value: i
                }],
                style: `background-image: url(${ configuration.back.source }); background-size: contain; background-position: center; background-repeat: no-repeat`
            });

            cardListContainer.appendChild( cardContainer )
        }

        carouselHtmlElement.appendChild(cardListContainer);

        const rightArrowContainer = Carousel.createElement({
            tag: 'div',
            id: 'app-emi-carousel-right-arrow',
            html: '<svg style="width:100%;height:48px" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>'
        });

        carouselHtmlElement.appendChild(rightArrowContainer);

        return carouselHtmlElement;
    }

    static render3D(){
        let OFFSET = -50;
        let ROTATION = 40;
        let BASE_ZINDEX = 10;
        let opacity = [1,.7,.3]
        let scale = [1,.9, .75]

        let elts = document.querySelectorAll('.app-emi-carousel-card');
        let position = document.querySelector('#app-emi-carousel-cardlist').getAttribute('data-emi-carousel-position');

        for(let i = 0; i < elts.length; i++){
            elts[i].style.opacity = 0;
            elts[i].style.display = 'inline-block';

            if(i < position){
                elts[i].style.transform = 'translateX( ' + ( OFFSET * (  position - i + 1) ) + '%) rotateY(' + ( ROTATION * ( position - i ) ) + 'deg) scale(' + (Math.abs(i - position) < 3 ? scale[Math.abs(i - position)] : 0) + ')';
                elts[i].style.zIndex = BASE_ZINDEX + i;
                elts[i].style.opacity = Math.abs(i - position) < 3 ? opacity[Math.abs(i - position)] : 0;
            }5

            if(i == position){
                elts[i].style.transform = 'translateX(-50%) rotateY(0deg)';
                elts[i].style.zIndex = 100;
                elts[i].style.opacity = 1;
            }

            if(i > position){
                elts[i].style.transform = 'translateX(' + Math.abs(OFFSET * (i - position - 1)) + '%) rotateY(-' + (ROTATION * (i - position))+ 'deg) scale(' + (Math.abs(i - position) < 3 ? scale[Math.abs(i - position)] : 0) + ')';
                elts[i].style.zIndex = BASE_ZINDEX + (elts.length - i);
                elts[i].style.opacity = opacity[i-position]
            }

            if(Math.abs(i - position) > 2){
                elts[i].style.display = 'none';
            }
        }
    }
}
